import {IGridSize} from "./interfaces";

/**
 * @deprecated
 */
export const defaultGridSize: IGridSize = {
  xs: 12,
  sm: 6,
  md: 2,
  lg: 2,
};
